/** Recent expenses for bank/account-name pickers (Settings, debit-card registry). */
export const QB_EXPENSES_ACCOUNT_DISCOVERY_LIMIT = 500;

/** P&L used to window expenses; outstanding now loads the full collection. Kept for account discovery tests. */
export const QB_EXPENSES_PL_LOOKBACK_MONTHS = 48;

/** @deprecated P&L no longer caps qbExpenses; discovery still uses a smaller limit. */
export const QB_EXPENSES_PL_MAX_DOCS = 3000;

/** ISO yyyy-mm-dd on or before which P&L ignores older QB expenses. */
export function qbExpensesProjectPLLookbackYmd(
  months = QB_EXPENSES_PL_LOOKBACK_MONTHS,
  now = new Date(),
): string {
  const d = new Date(now.getTime());
  d.setMonth(d.getMonth() - months);
  return d.toISOString().slice(0, 10);
}
